export const MESSAGE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'code',
];

export const MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'imageUpload',
];

export const ARTICLE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'underline',
  'strike',
  'code',
  'link',
  'h1',
  'h2',
  'h3',
  'bulletList',
  'orderedList',
  'blockquote',
  'codeBlock',
  'horizontalRule',
  'insertTable',
  'callout',
  'imageUpload',
  'imageAlignCenter',
  'undo',
  'redo',
];

export const MESSAGE_EDITOR_IMAGE_RESIZES = [
  {
    nameKey: 'CONVERSATION.EDITOR.IMAGE_RESIZE_SMALL',
    height: '24px',
  },
  {
    nameKey: 'CONVERSATION.EDITOR.IMAGE_RESIZE_MEDIUM',
    height: '48px',
  },
  {
    nameKey: 'CONVERSATION.EDITOR.IMAGE_RESIZE_LARGE',
    height: '72px',
  },
  {
    nameKey: 'CONVERSATION.EDITOR.IMAGE_RESIZE_ORIGINAL',
    height: 'auto',
  },
];

export const ARTICLE_CONTENT_MAX_LENGTH = 50000;
